import type { TranslationKey } from "@/i18n";

/** Member referral program — the "Invite a friend" screen + onboarding field. */
export const referralStrings = {
  title: "referral.title",
  subtitle: "referral.subtitle",
  yourCode: "referral.yourCode",
  copyCode: "referral.copyCode",
  copied: "referral.copied",
  share: "referral.share",
  shareMessage: "referral.shareMessage",
  shareWithCue: "referral.shareWithCue",
  /**
   * The two button LABELS, now that the actions sit side by side.
   *
   * Short because half a phone's width is not enough for a full sentence in
   * every locale — "Invite & send a Cue" already wraps to two lines, and
   * "Convidar e enviar um Cue" is longer still.
   *
   * These are also the ACCESSIBLE NAMES, not just the drawn text. An
   * accessible name that differs from the visible label breaks WCAG 2.5.3
   * "Label in Name" and leaves the control unreachable by voice. The long forms
   * above are the `accessibilityHint`s instead, which is the API for "what
   * happens if you activate this".
   */
  shareShort: "referral.shareShort",
  shareWithCueShort: "referral.shareWithCueShort",
  shareWithCueMessage: "referral.shareWithCueMessage",
  shareWithCueHint: "referral.shareWithCueHint",
  shareFailed: "referral.shareFailed",
  landingTitle: "referral.landingTitle",
  landingCueBody: "referral.landingCueBody",
  landingPlainBody: "referral.landingPlainBody",
  landingAccept: "referral.landingAccept",
  landingExpired: "referral.landingExpired",
  landingUsed: "referral.landingUsed",
  landingOwn: "referral.landingOwn",
  landingMissing: "referral.landingMissing",
  landingInvitedGeneric: "referral.landingInvitedGeneric",
  landingMobileWeb: "referral.landingMobileWeb",
  landingGetApp: "referral.landingGetApp",
  landingBrowse: "referral.landingBrowse",
  landingCueArrived: "referral.landingCueArrived",
  landingAlreadyTalking: "referral.landingAlreadyTalking",
  landingAlreadyConnected: "referral.landingAlreadyConnected",
  howItWorks: "referral.howItWorks",
  step1: "referral.step1",
  step2: "referral.step2",
  step3: "referral.step3",
  capNote: "referral.capNote",
  capReached: "referral.capReached",
  loadError: "referral.loadError",
  rewardActive: "referral.rewardActive",
  haveCode: "referral.haveCode",
  codePlaceholder: "referral.codePlaceholder",
  apply: "referral.apply",
  codeApplied: "referral.codeApplied",
  codeInvalid: "referral.codeInvalid",
  codeError: "referral.codeError",
} as const satisfies Record<string, TranslationKey>;
